import { render, staticRenderFns } from "./AddServicosComponent.vue?vue&type=template&id=b32fd7e2&"
import script from "./AddServicosComponent.vue?vue&type=script&lang=js&"
export * from "./AddServicosComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddServicosComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports